import React from 'react';

import heroImage from '../assets/hero-new.png';
import activityImg from '../assets/activity-new.png';
import durationImg from '../assets/duration-new.png';
import durationMobileImg from '../assets/duration-new.png';
import lecturesMobileImg from '../assets/activity-new.png';

const registrationLink =
  'https://docs.google.com/forms/d/e/1FAIpQLSfQkgc_5KSuyycJqj_zNFuG2QAfc-0NxZlsBvlbHH1AJAbKMw/viewform?usp=dialog';

const HeroSection = () => {
  return (
        <section
          id="home"
          className="
            relative flex w-full
            flex-col items-center
            overflow-hidden
            bg-[#0F081B]
            px-4 pb-12 pt-32
            font-['Montserrat'] text-white
            sm:px-8
            md:pb-16 md:pt-36
          "
        >

      {/* Підпис у правому верхньому куті — лише desktop */}
      <div className="absolute right-8 top-44 z-10 hidden lg:block">
        <span className="text-xl font-medium text-white/70 xl:text-2xl">
          Від студентів ФПН УКУ з{' '}
          <span role="img" aria-label="серце">
            💜
          </span>
        </span>
      </div>

      <div
        className="
          container mx-auto
          flex flex-col items-center justify-between
          gap-12
          md:px-6
          lg:flex-row lg:gap-16
        "
      >
        {/* Ліва колонка */}
        <div
          className="
            flex flex-1 flex-col
            items-center justify-center
            gap-6 text-center
            lg:items-start lg:text-left
          "
        >
          <h1
            className="
              flex flex-col
              text-5xl font-black
              leading-[0.85] tracking-[-0.04em]
              sm:text-6xl
              md:text-7xl
              lg:text-8xl
              xl:text-9xl
            "
          >
            <span className="uppercase text-white">
              APPS
            </span>

            <span className="text-[#E150A8]">
              SUMMER
            </span>

            <span className="uppercase text-[#7CF27A]">
              CAMP
            </span>
          </h1>

          {/* Підпис — лише mobile */}
          <div className="lg:hidden">
            <span className="text-base font-medium text-white/65">
              Від студентів ФПН УКУ з{' '}
              <span role="img" aria-label="серце">
                💜
              </span>
            </span>
          </div>

          <p
            className="
              max-w-xl
              text-base leading-relaxed
              text-white/75
              sm:text-lg
              md:text-xl
              lg:text-2xl
            "
          >
            Це{' '}
            <span className="font-bold text-[#3DFF80]">
              6-денний профорієнтаційний табір
            </span>{' '}
            для{' '}
            <span className="font-bold text-[#E150A8]">
              учнів 8–11 класів
            </span>
            . Під час табору учасники проходять адаптовані навчальні програми,
            створені на основі курсів, які викладаються в{' '}
            <span className="font-bold text-[#3DFF80]">
              УКУ
            </span>
            . Окрім навчальної частини, на учасників чекають командні активності,
            знайомства, практичні заняття, інтерактивні завдання та{' '}
            <span className="font-bold text-[#E150A8]">
              фінальний проєкт
            </span>
            .
          </p>

          <a
            href={registrationLink}
            target="_blank"
            rel="noopener noreferrer"
            className="
              mt-2
              rounded-full
              bg-[#3DFF80]
              px-8 py-3
              text-base font-extrabold
              text-[#0F081B]
              transition-all duration-200
              hover:-translate-y-1
              hover:bg-[#E150A8]
              md:mt-4
              md:px-10 md:py-4
              md:text-lg
            "
          >
            Доєднатись
          </a>
        </div>

        {/* Права колонка */}
        <div
          className="
            flex w-full max-w-lg flex-1
            flex-col items-center justify-center
            lg:max-w-none
          "
        >
          <div className="relative w-full">
            <img
              src={heroImage}
              alt="APPS Summer Camp"
              className="
                h-auto w-full
                rounded-3xl
                object-cover
              "
            />

            {/* Інформаційні картки — tablet і desktop */}
            <div className="mt-4 hidden w-full flex-row items-start gap-4 md:flex">
              <div className="flex-1">
                <img
                  src={durationImg}
                  alt="Тривалість табору"
                  className="h-auto w-full object-contain"
                />
              </div>

              <div className="flex-1">
                <img
                  src={activityImg}
                  alt="Активності табору"
                  className="h-auto w-full object-contain"
                />
              </div>
            </div>
          </div>

          {/* Інформаційні картки — mobile */}
          <div
            className="
              mt-6 flex w-full
              flex-col items-center justify-center
              gap-6
              md:hidden
            "
          >
            <div className="flex w-auto justify-center">
              <img
                src={durationMobileImg}
                alt="Тривалість табору"
                className="mx-auto h-auto max-w-[240px]"
              />
            </div>

            <div className="flex w-auto justify-center">
              <img
                src={lecturesMobileImg}
                alt="Лекції та заняття"
                className="mx-auto h-auto max-w-[280px]"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default HeroSection;
